import { AccountOrder, OrderStatus, SavedAddress } from '../types'
import { IMAGES } from './products'

export const ACCOUNT_PROFILE = {
  name: 'Ana Zapata',
  initials: 'AZ',
  since: 'enero 2024',
  email: 'ana.zapata@mail.com',
  firstName: 'Ana',
  lastName: 'Zapata',
  phone: '+598 99 456 780',
  birthDate: '1993-04-18',
  orders: 8,
  spent: 24560,
  tier: 'Cliente VIP',
}

export const ACCOUNT_STATUS_META: Record<
  OrderStatus,
  { label: string; badge: string }
> = {
  pendiente: {
    label: 'Pendiente',
    badge: 'bg-amber-500 text-black',
  },
  proceso: {
    label: 'En proceso',
    badge: 'bg-teal-500 text-black',
  },
  enviado: {
    label: 'Enviado',
    badge: 'bg-[#7c5cff] text-white',
  },
  entregado: {
    label: 'Entregado',
    badge: 'bg-emerald-500 text-black',
  },
}

export const ACCOUNT_ORDERS: AccountOrder[] = [
  {
    id: '#ZADAR-0042',
    date: '15 jul 2025',
    status: 'entregado',
    total: 3200,
    summary: 'Banda Elástica Pro + 2 más',
    itemCount: 3,
    tracking: '#TRK928374',
    address: 'Bvar. España 2140, apto 502 · Pocitos, Montevideo, CP 11300',
    payment: 'Tarjeta terminada en 4242',
    items: [
      {
        name: 'Banda Elástica Pro',
        image: IMAGES.bands,
        color: 'Rosa',
        quantity: 1,
        price: 990,
      },
      {
        name: 'Guantes Grip Black',
        image: IMAGES.gloves,
        color: 'Negro',
        quantity: 1,
        price: 1590,
      },
      {
        name: 'Soga Speed Rope',
        image: IMAGES.rope,
        color: 'Rosa',
        quantity: 1,
        price: 620,
      },
    ],
    timeline: [
      { label: 'Pedido recibido', date: '15 jul · 10:23', done: true },
      { label: 'En preparación', date: '15 jul · 14:00', done: true },
      { label: 'Enviado', date: '16 jul · 09:15', done: true },
      { label: 'Entregado', date: 'estimado 17 jul', done: false },
    ],
  },
  {
    id: '#ZADAR-0041',
    date: '02 jul 2025',
    status: 'enviado',
    total: 4490,
    summary: 'Kit Glute Builder + 1 más',
    itemCount: 2,
    tracking: '#TRK881204',
    address: 'Bvar. España 2140, apto 502 · Pocitos, Montevideo, CP 11300',
    payment: 'MercadoPago',
    items: [
      {
        name: 'Kit Glute Builder',
        image: IMAGES.kit,
        color: 'Violeta',
        quantity: 1,
        price: 3100,
      },
      {
        name: 'Tobilleras Lite 1kg',
        image: IMAGES.ankle,
        color: 'Turquesa',
        quantity: 1,
        price: 1390,
      },
    ],
    timeline: [
      { label: 'Pedido recibido', date: '02 jul · 08:40', done: true },
      { label: 'En preparación', date: '02 jul · 12:10', done: true },
      { label: 'Enviado', date: '03 jul · 10:05', done: true },
      { label: 'Entregado', date: 'estimado 05 jul', done: false },
    ],
  },
  {
    id: '#ZADAR-0040',
    date: '28 jun 2025',
    status: 'pendiente',
    total: 2490,
    summary: 'Corrector Postural Active',
    itemCount: 1,
    note: 'En preparación en nuestro depósito',
    address: 'Bvar. España 2140, apto 502 · Pocitos, Montevideo, CP 11300',
    payment: 'Transferencia bancaria',
    items: [
      {
        name: 'Corrector Postural Active',
        image: IMAGES.corrector,
        color: 'Negro',
        quantity: 1,
        price: 2490,
      },
    ],
    timeline: [
      { label: 'Pedido recibido', date: '28 jun · 19:52', done: true },
      { label: 'En preparación', date: 'pendiente', done: false },
      { label: 'Enviado', date: 'pendiente', done: false },
      { label: 'Entregado', date: 'pendiente', done: false },
    ],
  },
]

export const SAVED_ADDRESSES: SavedAddress[] = [
  {
    id: 'a1',
    label: 'Casa',
    primary: true,
    address: 'Bvar. España 2140, apto 502 · Pocitos, Montevideo, CP 11300',
    phone: '+598 99 456 780',
  },
  {
    id: 'a2',
    label: 'Trabajo',
    primary: false,
    address: 'Zonamérica, Ruta 8 km 17.500, of. 204 · Montevideo, CP 91600',
    phone: '+598 2518 4400',
  },
]
